import { Theme, css } from '@emotion/react';

export const heroWidget = ({ breakpoints, spacing }: Theme) => css`
  margin-bottom: ${spacing(3)}px;
  ${breakpoints.up('md')} {
    margin-bottom: ${spacing(4.5)}px;
  }
`;

export const gridContainer = css`
  & .MuiGrid-container {
    margin-top: 0;
  }
`;

export const topSectionBackdrop = ({ breakpoints, colors, spacing }: Theme) => css`
  background-color: ${colors.bgLight};
  margin-bottom: ${spacing(2)}px;
  padding-bottom: ${spacing(2)}px;

  ${breakpoints.up('md')} {
    margin-bottom: ${spacing(6)}px;
  }
`;
